var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field"},[_c('label',{staticClass:"text-caption"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"text-body-1 font-weight-medium"},[_vm._v(" "+_vm._s(_vm.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }